import React from 'react'

const patientContext = React.createContext()

export default patientContext
